import React, { useContext } from "react";
import Main from "./Main";
import Login from "./Login";
import { Route, Switch, Redirect } from "react-router-dom";
import { UserContext } from "./UserContext";
import SignUp from "./SignUp";

const Routes = () => {
  const { user } = useContext(UserContext);
  return (
    <Switch>
      <Route
        exact
        path="/login"
        component={props => <Login {...props} user={user} />}
      />
      <Route
        exact
        path="/map"
        component={props => <Main {...props} user={user} />}
      />
      <Route
        exact
        path="/signup"
        component={props => <SignUp {...props} user={user} />}
      />
      <Route
        path="/"
        component={() => (
          <div>
            <Redirect to="/login" />
          </div>
        )}
      />
    </Switch>
  );
};

export default Routes;
